import KeyOutlinedIcon from '@mui/icons-material/KeyOutlined';
import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';
import { ContainerComponent } from '../components/container/container.component';
import { ResizableSplitLayoutComponent } from '../components/resizable-split-layout/resizable-split-layout.component';
import { SidebarButtonsItemComponent } from '../components/sidebar-buttons/sidebar-buttons-item/sidebar-buttons-item.component';
import { SidebarButtonsComponent } from '../components/sidebar-buttons/sidebar-buttons.component';

export function SettingsPage() {
  const { t } = useTranslation();

  return (
    <ResizableSplitLayoutComponent
      left={
        <SidebarButtonsComponent>
          <Typography variant="h5">{t('settings.title')}</Typography>
          <SidebarButtonsItemComponent
            title={t('settings.tokens.tab')}
            icon={<KeyOutlinedIcon />}
            to="/settings/tokens"
          />
          <SidebarButtonsItemComponent
            title={t('settings.sharedChats.tab')}
            icon={<ShareOutlinedIcon />}
            to="/settings/shared-chats"
          />
        </SidebarButtonsComponent>
      }
      right={
        <ContainerComponent>
          <Outlet />
        </ContainerComponent>
      }
    />
  );
}
